<script setup lang="ts">
import type { Schemas } from "#shopware";
import { formatDateDistance } from "../../../helpers/formatters";

const props = defineProps<{
	product: Schemas["Product"];
}>();

const { product } = toRefs(props);

const { loadProductReviews, productReviews } = useProductReviews(product);

onMounted(() => {
	loadProductReviews({
		limit: 5,
		sort: [
			{
				field: "createdAt",
				order: "DESC",
				naturalSorting: false
			}
		]
	});
});

const { data: stats, status } = await useAsyncData(
	`reviews:${product.value.id}`,
	() => useShopwareProductReviewStats(product.value),
	{ server: false, lazy: true }
);
</script>
<template>
	<div class="flex flex-col gap-4">
		<span class="text-sm font-bold">Overzicht van scores</span>
		<LazyCreateReviewForm />

		<p v-if="status === 'pending' || status === 'idle'">Reviews laden...</p>

		<template v-if="!!stats">
			<div class="flex flex-col" v-if="status === 'success' && !!stats">
				<KippieReviewCharts :label="5" :amount="stats.fiveStarCount" :total="stats.totalCount" />
				<KippieReviewCharts :label="4" :amount="stats.fourStarCount" :total="stats.totalCount" />
				<KippieReviewCharts :label="3" :amount="stats.threeStarCount" :total="stats.totalCount" />
				<KippieReviewCharts :label="2" :amount="stats.twoStarCount" :total="stats.totalCount" />
				<KippieReviewCharts :label="1" :amount="stats.oneStarCount" :total="stats.totalCount" />
			</div>

			<KippieReviewComment
				v-for="review in productReviews"
				:key="review.id"
				:title="review.title || ''"
				:date="formatDateDistance(review.createdAt)"
				:review="review.points || 0"
			>
				{{ review.content }}
			</KippieReviewComment>
		</template>
	</div>
</template>
